export default __webpack_public_path__ + "static/media/4.126cede8.jpg";